import request from "../../../util/SuperagentUtils";
import type {SuperAgentRequest} from "superagent";

export const requestAddPaymentMethod = (data: string): SuperAgentRequest => {
  return request
    .post("/api/payment-method")
    .set("Content-Type", "application/json")
    .send(data);
}

export const requestToken = (account: {id: string}): SuperAgentRequest => {
  return request
    .get(`/api/payment-method/token?accountId=${account.id}`)
}
